<template>
  <v-dialog
    class="modal__wrapper"
    width="1347"
    :value="true"
    @input="$emit('close-modal')"
  >
    <v-card class="modal__card">
      <div class="modal__header">
        <div class="modal__header-title">
          <h5 class="my-4">Foundational Reports</h5>
          <h1 v-html="topic.title"></h1>
        </div>
        <div class="modal__header-close">
          <v-btn
            icon
            color="primary"
            @click="$emit('close-modal'), (topicId = null)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <p class="modal__description" v-html="topic.description"></p>

      <div class="modal__body">
        <div class="modal__reltopic">
          <ViewReportsModalRelatedTopics
            class="mb-8"
            :topics="topic.topics"
            @changeTopic="changeTopic"
          >
            <template v-slot:default>
              <v-btn
                @click="prev"
                v-if="selectedItems.length > 1"
                class="back__button d-block d-sm-none float-right"
              >
                <v-icon> mdi-chevron-left </v-icon>
                Back to previous
              </v-btn>
            </template>
          </ViewReportsModalRelatedTopics>
          <v-btn
            @click="prev"
            v-if="selectedItems.length > 1"
            class="back__button d-none d-sm-block"
          >
            <v-icon> mdi-chevron-left </v-icon>
            Back to previous
          </v-btn>
        </div>
        <div class="modal__reports">
          <ViewReportsModalReports :contentId="data.id" :reports="topic.url" />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SEGMENT_EVENTS } from '../../constants';
import ViewReportsModalRelatedTopics from './ViewReportsModalRelatedTopics.vue';
import ViewReportsModalReports from './ViewReportsModalReports.vue';

const replaceParams = (path, prev, curr) => {
  if (!prev || !curr) {
    return path;
  }
  return path.replace(prev, curr); 
};

export default {
  name: 'ViewReportsModal',
  components: {
    ViewReportsModalRelatedTopics,
    ViewReportsModalReports,
  },
  props: {
    data: {
      type: [Object, String, Array],
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['reports']),
    topic () {
      if (this.topicId) {
        var topic = this.reports.find(r => r.id === this.topicId);
        if (topic) {
          return topic;
        }
      }
      return this.data;
    },
  },
  watch: {
    '$route.params.id': {
      handler (value) {
        this.topicId = value;
      },
      deep: true,
      immediate: true,
    },
    value() {
      this.selectedItems = [];
      this.selectedItems.push(this.data.id);
    },
  },
  data () {
    return {
      topicId: null,
      selectedItems: [],
    };
  },
  created() {
    this.selectedItems.push(this.data.id);
  },
  methods: {
    ...mapActions([
      'setCurrentFoundationalReport'
    ]),
    changeTopic(topic) {
      if (topic) {
        this.topicId = topic.id;
        this.setCurrentFoundationalReport(topic);
        this.selectedItems.push(this.topicId);
        window.analytics.track(
          SEGMENT_EVENTS.CLICKED_FOUNDATIONAL_REPORT_RELATED_TOPIC,
          {
            contentTitle: topic.title,
            contentId: topic.id,
            contentType: 'Foundational Reports',
          }
        );
        history.pushState(
          {},
          null,
          replaceParams(this.$route.path, this.$route.params.id, topic.id),
        );
      }
    },
    prev() {
      if (this.selectedItems.length != 1) {
        let prevItem = this.selectedItems[this.selectedItems.length - 2];
        this.topicId = prevItem;
        this.selectedItems.pop();
        history.pushState(
          {},
          null,
          replaceParams(this.$route.path, this.$route.params.id, prevItem),
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal__card {
  background: #f6f7f8;
  padding: 40px 44px;
  height: 600px;
  overflow: scroll;
  @media (max-width: 960px) {
    padding: 24px 8px;
  }
}
.modal__header {
  position: relative;
  &-title h5 {
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.1px;
    color: var(--v-primary-base);
    margin-bottom: 6px;
  }
  &-title h1 {
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #234025;
    margin-bottom: 10px;
  }
  &-close {
    position: absolute;
    right: -12px;
    top: -12px;
    @media (max-width: 960px) {
      right: 10px;
      top: -6px;
    }
  }
  @media (max-width: 960px) {
    padding: 0 8px;
  }
}
.modal__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.1px;
  color: #4f425e;
  margin-bottom: 30px;
  @media (max-width: 960px) {
    padding: 0 8px;
  }
}
.modal__body {
  min-height: 300px;
  .back__button {
    background-color: #029f48;
    color: #fff;
    text-transform: none;
    width: 8.0625rem;
    height: 1.5rem;
    border-radius: 0;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 0.9375rem;
    letter-spacing: 0.2px;
    box-shadow: none;
  }
  .back__button i {
    font-size: 1rem !important;
  }
  display: flex;
  .modal__reltopic {
    width: 255px;
    margin-right: 32px;
  }
  .modal__reports {
    flex: 1;
  }
  @media (max-width: 960px) {
    flex-direction: column;

    .modal__reltopic {
      margin-top: 16px;
      width: 100%;
      margin-right: 0;
      order: 2;
    }
    .modal__reports {
      order: 1;
    }
  }
}
</style>
